import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { Receipt, ReceiptCreateDTO, ReceiptEditDTO, ReceiptEditHistory } from '../interfaces/sales/receipt.interface';

export const ReceiptService = {
  listByInvoice: async (invoiceId: string): Promise<Receipt[]> =>
    (await axios.get(ENDPOINTS.RECEIPT.LIST_BY_INVOICE(invoiceId))).data,
  getById: async (id: string): Promise<Receipt> =>
    (await axios.get(ENDPOINTS.RECEIPT.GET_BY_ID(id))).data,
  create: async (dto: ReceiptCreateDTO): Promise<Receipt> =>
    (await axios.post(ENDPOINTS.RECEIPT.CREATE, dto)).data,
  reverse: async (id: string): Promise<Receipt> =>
    (await axios.post(ENDPOINTS.RECEIPT.REVERSE(id))).data,
  edit: async (id: string, dto: ReceiptEditDTO): Promise<Receipt> =>
    (await axios.put(ENDPOINTS.RECEIPT.EDIT(id), dto)).data,
  editHistory: async (id: string): Promise<ReceiptEditHistory[]> =>
    (await axios.get(ENDPOINTS.RECEIPT.EDIT_HISTORY(id))).data,
};
